import * as React from 'react';

import { Box, BlockWrapper, Button, TextError, TextRow, Typography } from 'components';

import { Currency } from 'enums';
import { ParticipantList } from '../ParticipantList';
import { TEXT } from 'texts';
import { formatAmount, useBreakpoints } from "utils";
import { observer } from 'mobx-react-lite';
import { paths } from 'routing';
import { useHistory } from 'react-router';
import { useStores } from 'hooks';
import { useTranslation } from 'react-i18next';
import { useStyles } from './ParticipantForm.styles';
import { Status } from 'types';

const ParticipantForm = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { dataStore } = useStores();
  const [errored, setErrored] = React.useState<boolean>(false);
  const { isMd } = useBreakpoints()
  const styles = useStyles();

  React.useEffect(() => {
    if (errored && dataStore.selectedParticipant) {
      setErrored(false);
    }
  }, [dataStore.selectedParticipant, errored]);

  const isFormValid = !!dataStore.selectedParticipant;

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isFormValid) {
      history.push(paths.p2p);
    } else {
      setErrored(true);
    }
  };

  const status = <span className={styles[dataStore.appData?.status as Status]}>
    {t(TEXT.statusActive)}
  </span>;

  return (
    <form onSubmit={handleSubmit}>
      <Typography textType="text" textColor="grey" className={styles.title}>
        {t(TEXT.findYourself)}
      </Typography>
      <ParticipantList />

      <BlockWrapper mt={3}>
        {!isMd && <TextRow
          title={t(TEXT.totalAmount)}
          text={`${formatAmount({ amount: dataStore.appData?.amount })} ${Currency.UAH}`}
        />}
        {(!!dataStore.appData?.status && dataStore.appData?.amount && !isMd) && (
          <Box mt={4}>
            <TextRow title={t(TEXT.comment)} subtitle={dataStore.appData.recipient.purposeText} />
          </Box>
        )}
        {(!!dataStore.appData?.recipient.purposeText && isMd) && (
          <Box>
            <TextRow
              title={t(TEXT.status)}
              text={status}
              subtitle={`${t(TEXT.expiresIn)} ${dataStore.appData.expireDateApp}`}
            />
          </Box>
        )}
      </BlockWrapper>

      {dataStore.hasParticipants && <Box mt={3}>
        <Typography textType="hint" textColor="grey" align="center">{t(TEXT.changeAmountHint)}</Typography>
      </Box>}

      {errored && (
        <Box mt={3} display="flex" justifyContent="center">
          <TextError text={TEXT.errorChooseYourself} />
        </Box>
      )}
      <Box mt={3}>
        <Button fullWidth type="submit" buttonType="round" background="gradient">
          <Typography textType="button" textColor="white">
            {t(TEXT.send)}
          </Typography>
        </Button>
      </Box>
    </form>
  );
};

export default observer(ParticipantForm);
